// ajay:code 19-08-26
import { Plus, Trash2 } from "lucide-react";
import FailureModeBlock from "./FailureModeBlock";

const emptyFailureMode = () => ({
  failure_mode_text: "",
  severity: "",
  class: "",
  effects: [],
  causes: [],
});

export default function RequirementBlock({
  requirement,
  onChange,
  onDelete,
  readOnly,
}) {
  const set = (field, value) => onChange({ ...requirement, [field]: value });
  const failureModes = requirement.failure_modes || [];

  const updateFailureMode = (i, updated) => {
    const next = [...failureModes];
    next[i] = updated;
    set("failure_modes", next);
  };
  const addFailureMode = () =>
    set("failure_modes", [...failureModes, emptyFailureMode()]);
  const removeFailureMode = (i) =>
    set(
      "failure_modes",
      failureModes.filter((_, idx) => idx !== i),
    );

  return (
    <div
      style={{
        background: "var(--surface)",
        border: "1px solid var(--border2)",
        borderLeft: "3px solid var(--accent2)",
        borderRadius: 8,
        padding: 12,
        marginBottom: 10,
      }}
    >
      <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontSize: 10,
              color: "var(--accent2)",
              fontWeight: 700,
              marginBottom: 3,
            }}
          >
            REQUIREMENT
          </div>
          {readOnly ? (
            <div style={{ fontSize: 13 }}>
              {requirement.requirement_text || "—"}
            </div>
          ) : (
            <input
              type="text"
              value={requirement.requirement_text || ""}
              placeholder="e.g. Free from packing damage"
              onChange={(e) => set("requirement_text", e.target.value)}
              style={{
                width: "100%",
                padding: "6px 8px",
                fontSize: 13,
                borderRadius: 6,
                border: "1px solid var(--border2)",
                background: "var(--surface2)",
                color: "var(--text)",
              }}
            />
          )}
        </div>
        {!readOnly && (
          <button
            type="button"
            title="Delete requirement"
            onClick={onDelete}
            style={{
              background: "none",
              border: "none",
              color: "var(--danger)",
              cursor: "pointer",
              marginTop: 18,
            }}
          >
            <Trash2 size={15} />
          </button>
        )}
      </div>

      <div
        style={{
          marginTop: 8,
          paddingLeft: 10,
          borderLeft: "2px solid var(--border2)",
        }}
      >
        <div
          style={{
            fontSize: 10,
            color: "var(--text3)",
            fontWeight: 700,
            marginBottom: 6,
          }}
        >
          FAILURE MODES ({failureModes.length})
        </div>
        {failureModes.map((fm, i) => (
          <FailureModeBlock
            key={i}
            failureMode={fm}
            onChange={(updated) => updateFailureMode(i, updated)}
            onDelete={() => removeFailureMode(i)}
            readOnly={readOnly}
          />
        ))}
        {!readOnly && (
          <button
            type="button"
            onClick={addFailureMode}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              background: "var(--surface2)",
              border: "1px solid var(--border2)",
              borderRadius: 6,
              padding: "5px 10px",
              fontSize: 11,
              fontWeight: 600,
              color: "var(--accent)",
              cursor: "pointer",
            }}
          >
            <Plus size={12} /> Add Failure Mode
          </button>
        )}
      </div>
    </div>
  );
}
